import React from 'react';

import { colorsPalette } from '../../theme';
import useStyles from './styles';

const MenuIcon = (props) => {
  const color = props?.color || colorsPalette.white;
  const classes = useStyles()();

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
      color={color}
    >
      <line className={classes.element} x1="1.99999" y1="4" x2="22.00001" y2="4" />
      <line className={classes.element} x1="1.99999" y1="12.00001" x2="22.00001" y2="12.00001" />
      <line className={classes.element} x1="1.99999" y1="20.00001" x2="22.00001" y2="20.00001" />
    </svg>
  );
};

export default MenuIcon;
